import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 33 32"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M23.385 5.062h3.655l-7.984 9.126 9.393 12.417h-7.355l-5.76-7.53-6.591 7.53H5.086l8.54-9.76-9.01-11.783h7.54l5.207 6.884 6.022-6.884Zm-1.282 19.356h2.025L11.056 7.135H8.883l13.22 17.283Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }